<template>
  <div class="welfare-detail">
    <div class="performance-item-content" v-if="item">
      <!-- <h3 class="font-web performance-item-title">{{ item.title }}</h3> -->
      <div class="font-web mb-20" v-html="item.description" v-if="item.description"></div>

      <div class="content-section mb-10" v-if="item.content">
        <h4 class="font-web section-label">รายละเอียด / Description</h4>
        <div class="font-web mt-0 mb-0" style="white-space: pre-line" v-html="item.content"></div>
      </div>

      <div v-if="item.docs && item.docs.length > 0" class="mt-20">
        <table class="doc-table">
          <thead>
            <tr>
              <th>รายการไฟล์ / File List</th>
              <th class="text-center">Download</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(doc, idx) in item.docs" :key="idx">
              <td>
                <div class="file-name-main">{{ doc.thName }}</div>
                <div v-if="doc.enName" class="file-name-sub">({{ doc.enName }})</div>
                <div v-if="doc.updatedAt" class="file-date">อัปเดตเมื่อ: {{ formatDate(doc.updatedAt) }}</div>
              </td>
              <td class="text-center">
                <a v-if="doc.thLink" :href="doc.thLink" target="_blank" class="download-link">
                  <a-icon type="download" />
                </a>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-15" v-if="item.link">
        <a-button type="primary" :href="item.link" target="_blank">
          อ่านรายละเอียดเพิ่มเติม
        </a-button>
      </div>
    </div>
    <div v-else>
      <a-empty description="ไม่มีข้อมูล" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
  }
};
</script>

<style scoped>
.performance-item-title {
  font-size: 20px !important;
  font-weight: 800 !important;
  color: #1a1a2e !important;
  margin-bottom: 16px;
}

.performance-item-content {
  color: #595959;
  font-size: 14px;
  line-height: 1.6;
}

.section-label {
  font-size: 13px;
  font-weight: 700;
  color: #8c8c8c;
  text-transform: uppercase;
  margin-bottom: 5px;
  letter-spacing: 0.5px;
}

.doc-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.doc-table th {
  background: #1a1a2e;
  padding: 12px 15px;
  text-align: left;
  font-weight: 700;
  color: #ffffff;
  border-bottom: 2px solid #4285F4;
}

.doc-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
  color: #434343;
}

.file-name-main {
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.4;
}

.file-name-sub {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 2px;
  font-style: italic;
}

.file-date {
  font-size: 11px;
  color: #bfbfbf;
  margin-top: 4px;
}

.text-center {
  text-align: center;
}

.download-link {
  color: #4285F4;
  font-size: 18px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.download-link:hover {
  color: #1a73e8;
  transform: translateY(-2px);
}

.mt-15 {
  margin-top: 15px;
}

.mt-20 {
  margin-top: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-10 {
  margin-bottom: 10px;
}
</style>
